export default __webpack_public_path__ + "static/media/OrkinProLogo.04916521.jpg";